import PropTypes from "prop-types";
import { Button } from "antd";
import { useHistory } from "react-router-dom";

const PaymentFailureView = ({ reservationId, t }) => {
    const history = useHistory();

    return (
        <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-12 text-center">
            <h1 className="fontSemi text-2xl text-[#2F2F46]">{t("paymentFailedTitle")}</h1>
            <p className="fontRegular mt-3 max-w-md text-sm text-[#7f8c8d]">{t("paymentFailedBody")}</p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
                <Button onClick={() => history.push(`/reservations/${reservationId}/add-coverage`)}>
                    {t("tryAgain")}
                </Button>
                <Button type="primary" onClick={() => history.push(`/reservations/${reservationId}`)}>
                    {t("backToReservation")}
                </Button>
            </div>
        </div>
    );
};

PaymentFailureView.propTypes = {
    reservationId: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
};

export default PaymentFailureView;
